import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Blocks from '../blocks/Blocks';
import SelectionCard from '../cards/Selection';
import PageMeta from '../partials/PageMeta';
import Title from '../typography/Title';

import styles from '../../../styles/pages/selections.module.css';

const propTypes = { page: PropTypes.shape({ id: PropTypes.string }) };

function SelectionsPage({ page = null }) {
    const { title = null, selections = null, blocks = null } = page || {};

    return (
        <div className={styles.container}>
            <PageMeta page={page} />
            <Title className={styles.pageTitle} size="large">
                {title}
            </Title>
            {selections !== null && selections.length > 0 ? (
                <div className={styles.section}>
                    <div className={classNames([styles.grid, styles.selections])}>
                        {(selections || []).map((selection) => (
                            <SelectionCard
                                key={`selection-${selection?.id}`}
                                className={styles.selection}
                                item={selection}
                            />
                        ))}
                    </div>
                </div>
            ) : null}
            {blocks !== null && blocks.length > 0 ? (
                <Blocks className={styles.blocks} blocks={blocks} />
            ) : null}
        </div>
    );
}

SelectionsPage.propTypes = propTypes;

export default SelectionsPage;
